import { FormControl } from 'baseui/form-control'
import SDDatePicker from '@/shared/components/SDComponents/SDDatePicker'
import { SIZE } from 'baseui/button'

interface ByCreationDateProps {
  label: string
  onDateChangeHandler: (date: string) => void
}

const ByCreationDate = ({ label, onDateChangeHandler }: ByCreationDateProps) => {
  return (
    <FormControl label={label}>
      <SDDatePicker
        size={SIZE.compact}
        formatString='dd/MM/yyyy'
        onChange={({ date }: { date: unknown }) => {
          let finalDate = ''
          if (date) {
            finalDate = new Date(date + ' UTC').toISOString().slice(0, 10)
          }
          onDateChangeHandler(finalDate)
        }}
      />
    </FormControl>
  )
}

export default ByCreationDate
